import { Core } from '@springtree/eva-services-core';
import buildServiceState from '../../builders/build-service-state.js';
import { getReactRecoilSettings } from '../../settings.js';
const productBundleListState = buildServiceState({
    key: 'productBundleList',
    service: Core.ListProductBundles,
    beforeRequest: ({ req }) => {
        const settings = getReactRecoilSettings();
        const defaultRequest = {
            PageConfig: {
                Start: 0,
                Limit: settings.defaultPageSize,
            },
            IncludedFields: settings.defaultProductProperties,
        };
        const newRequest = {
            ...defaultRequest,
            ...req,
        };
        return newRequest;
    },
});
export default productBundleListState;
//# sourceMappingURL=product-bundle-list-state.js.map